import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://resto-demo-1ba97.firebaseio.com/',
});

export default instance;